import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=6b85ef1c&scoped=true&"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=6b85ef1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85ef1c",
  null
  
)

export default component.exports